import { render, staticRenderFns } from "./DetailHardwareBooking.vue?vue&type=template&id=56297550&scoped=true&"
import script from "./DetailHardwareBooking.vue?vue&type=script&lang=js&"
export * from "./DetailHardwareBooking.vue?vue&type=script&lang=js&"
import style0 from "./DetailHardwareBooking.vue?vue&type=style&index=0&id=56297550&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56297550",
  null
  
)

export default component.exports